export const replaceValue = array => {
  return array.replace(/[- )(]/g, '')
}
